import styled from '@emotion/styled';
import { css } from "@emotion/react";

export const TableContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid #C7C9DA;
    border-radius: 3px;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: 20px;
`;

export const TableRaw = styled.div<{ isHeader?: boolean }>`
    display: flex;
    border-bottom: 1px solid #C7C9DA;
    
    ${({ isHeader }) => isHeader && css`
        background: #f1f1f1;
        top: 0;
        position: sticky;
    `}

    &:last-child {
        border-bottom: none;
    }
`

export const TableRawItem = styled.span<{ isCheckbox?: boolean, withBorder?: boolean, isBold?: boolean }>`
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    ${({ isCheckbox }) => isCheckbox && css`
        width: auto;
        min-width: 28px;
    `}
    
    ${({ withBorder }) => withBorder && css`
        border-left: 1px solid #C7C9DA;
    `}

    ${({ isBold }) => isBold && css`
        font-weight: bolder;
    `}
`